import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import { breakpoints, Colors } from '../../../../../src/constants/style-constants';
import Icon from '../../../../../src/components/lib/Icon';
import FSFlatButton from '../../../../../src/components/lib/FSFlatButton';
import componentBase from '../../../../../src/lib/component-base';
import onResize from '../../../../../src/lib/on-resize';
import { openTab } from '../../../../../src/utils/openTab';
import SubscriptionButton from './SubscriptionButton';
import LogoLink from './children/LogoLink';
import AppBarChildren from './children/AppBarChildren';
import FSMenuItem from './children/FSMenuItem';

import FSFGLogo from '../../../../../static/images/FSFGLogo.png';
// import AirlineOTPIcon from '../../../../../static/images/menu-icons/AirlineOTP-Icon.svg';
// import AirportDelaysIcon from '../../../../../static/images/menu-icons/DelMa-Icon.svg';
// import AirportOTPIcon from '../../../../../static/images/menu-icons/AirportOTP-Icon.svg';
// import CreateAccountIcon from '../../../../../static/images/menu-icons/CreAc-Icon.svg';
// import CurrentConditionsIcon from '../../../../../static/images/menu-icons/CurCon-Icon.svg';
// import DataExportIcon from '../../../../../static/images/menu-icons/DataExports-Icon.svg';
// import DeparturesArrivalsIcon from '../../../../../static/images/menu-icons/DepAr-Icon.svg';
// import FAQIcon from '../../../../../static/images/menu-icons/FAQ-Icon.svg';
// import FlightTrackerIcon from '../../../../../static/images/menu-icons/Tracker-Icon.svg';
// import GlobalCancelDelaysIcon from '../../../../../static/images/menu-icons/GlobalCancelDelays-icon.svg';
// import HistoricalIcon from '../../../../../static/images/menu-icons/Historical-Icon.svg';
// import LoginIcon from '../../../../../static/images/menu-icons/Login-Icon.svg';
// import LogoutIcon from '../../../../../static/images/menu-icons/Logout-Icon.svg';
// import SettingsIcon from '../../../../../static/images/menu-icons/Sett-Icon.svg';
// import SupportIcon2 from '../../../../../static/images/menu-icons/Support-Icon2.svg';
import facebookIcon from '../../../../../static/images/social-follow/Facebook-Circle.svg';
import linkedinIcon from '../../../../../static/images/social-follow/LinkedIn-Circle.svg';
import twitterIcon from '../../../../../static/images/social-follow/Twitter-Circle.svg';
import youtubeIcon from '../../../../../static/images/social-follow/YouTube-Circle.svg';

const helpDeskLink = 'https://helpdesk.flightstats.com/hc/en-us';
const supportLink = 'https://helpdesk.flightstats.com/tickets/new';

const hiddenHeaderPaths = [
  '/account/invoice',
];

const logoLinkAnchorClass = 'fs-header-logo';
const logoLinkImgClass = 'fs-header-logo';

MenuItem.defaultProps = {
  style: {
    color: 'black',
  },
};

@onResize()
@componentBase('HeaderComponent')
export default class HeaderComponent extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    logout: PropTypes.func,
    user: PropTypes.object,
    isLoading: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);

    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.menuItemClickHandler = this.menuItemClickHandler.bind(this);
    this.onNavItemSelected = this.onNavItemSelected.bind(this);
    this.onHamburgerTap = this.onHamburgerTap.bind(this);
    this.state = {
      visibleMenu: '',
      menuOpen: false,
      mobile: context.mediaBreakpoint.isMobile,
    };
    this.resize = null;
  }

  componentDidMount() {
    this.initResizeListener();
    this.resize = setTimeout(() => this.handleResize, 10);
  }

  componentWillUnmount() {
    this.removeResizeListener();
    if (this.resize) {
      clearTimeout(this.resize);
    }
  }

  onHamburgerTap() {
    this.setState({ menuOpen: !this.state.menuOpen });
    this.context.reportButtonPress('Hamburger');
  }

  onNavItemSelected() {
    this.setState({ menuOpen: false });
  }

  getLogoLinkMobileClass = mobile => (mobile ? ' mobile' : '')

  hideHeader = (pathname) => {
    const bool = hiddenHeaderPaths.reduce((prev, hiddenPath) => {
      if (prev) {
        return prev;
      }
      return pathname.includes(hiddenPath);
    }, false);
    return bool;
  }

  menuItemClickHandler(path, action) {
    return () => {
      this.onNavItemSelected();
      this.context.goto(path, action);
    };
  }

  hideMenu() {
    this.setState({ visibleMenu: '' });
  }

  showMenu(evt) {
    this.setState({ visibleMenu: evt.currentTarget.id });
  }

  handleResize = () => {
    this.setState({
      mobile: this.mediaBreakpoint.isMobile || (this.mediaBreakpoint.value <= breakpoints.tablet),
    });
  };

  logout = () => {
    this.props.logout()
      .then(() => {
        this.context.goto('/account/login', 'Logout');
      });
  };

  reportButtonPressValue = (value) => {
    this.context.reportButtonPress('HeaderSubscriptionButton', value);
  }

  bigBlueAccountButton = () => {
    if (this.props.user) {
      return (
        <SubscriptionButton
          dispatch={this.props.dispatch}
          location={this.props.location}
          user={this.props.user}
          reportButtonPressValue={(value) => {
            this.onNavItemSelected();
            this.reportButtonPressValue(value);
          }}
          style={FSFlatButton.style({ marginRight: '10px' })}
          wrapperStyle={{ display: 'inline-block' }}
        />
      );
    }

    return (
      <FSFlatButton
        label='CREATE ACCOUNT'
        style={FSFlatButton.style({ marginRight: '10px' })}
        backgroundColor={Colors.blue6}
        hoverColor={Colors.blue8}
        className='signup-button'
        onClick={this.menuItemClickHandler('/register/plan', 'SignUp')}
        secondary
      />
    );
  }

  createDrawerSection = (title, items) => (
    <section>
      <p style={{
        color: '#5F5F5F',
        margin: '12px 0 4px 0',
        padding: '0 0 0 12px',
      }}
      >
        {title}
      </p>
      {items}
    </section>
  );

  createMenuItem = item => (
    <FSMenuItem
      {...item}
      key={item.key}
      mobile={this.state.mobile}
      openTabHandler={this.openTabHandler}
      menuItemClickHandler={
        item.linkTo.includes('http') ?
        () => null :
        this.menuItemClickHandler
      }
    />
  );

  createHeaderNavItem = (id, title, menu, additionalClass) => (
    <span
      className={`nav-item ${additionalClass || ''}`}
      onMouseEnter={this.showMenu}
      onMouseLeave={this.hideMenu}
      id={id}
    >
      {title}
      {menu}
    </span>
  )

  subscriptionActive = () => (this.props.user && this.props.user.subscriptionActive);
  proSubscription = () => (this.subscriptionActive() && this.props.user.subscriptionLevel >= 3);

  flightsMenuItems = () => [
    this.createMenuItem({
      key: 'flights-menu-item-1',
      primaryText: 'Flight Tracker',
      linkTo: '/flight-tracker/search',
      // leftIcon: FlightTrackerIcon,
      onClickTerm: 'Menu: Flights > Flight Tracker',
    }),
    this.createMenuItem({
      key: 'flights-menu-item-2',
      primaryText: 'Historical Flight Status',
      linkTo: '/historical-flight/search',
      // leftIcon: HistoricalIcon,
      showLock: !this.proSubscription(),
      onClickTerm: 'Menu: Flights > Historical',
    }),
    this.createMenuItem({
      key: 'flights-menu-item-3',
      primaryText: 'Alerts',
      linkTo: '/flight-alerts/home',
      // leftIcon: this.context.images.menuIcons.flightAlerts,
      showLock: !this.subscriptionActive(),
      onClickTerm: 'Menu: Flights > Alerts',
    }),
    this.createMenuItem({
      key: 'flights-menu-item-4',
      primaryText: 'Data Exports',
      linkTo: '/data-exports/home',
      // leftIcon: DataExportIcon,
      onClickTerm: 'Menu: Flights > Data Exports',
    }),
  ];

  airportsMenuItems = () => [
    this.createMenuItem({
      key: 'airports-menu-item-1',
      primaryText: 'Current Conditions',
      linkTo: '/airport-conditions/search',
      // leftIcon: CurrentConditionsIcon,
      onClickTerm: 'Menu: Airports > Current Conditions',
    }),
    this.createMenuItem({
      key: 'airports-menu-item-2',
      primaryText: 'Departures and Arrivals',
      linkTo: '/airports/departing-arriving/search',
      // leftIcon: DeparturesArrivalsIcon,
      showLock: !this.subscriptionActive(),
      onClickTerm: 'Menu: Airports > Departures and Arrivals',
    }),
    this.createMenuItem({
      key: 'airports-menu-item-3',
      primaryText: 'Airport Delays',
      linkTo: '/airport-delays',
      // leftIcon: AirportDelaysIcon,
      onClickTerm: 'Menu: Airports > Delays',
    }),
  ];

  openTabHandler = (link, label) => (
    (e) => {
      openTab(link, e);
      this.context.reportButtonPress(label);
    }
  );

  resourcesMenuItems = () => [
    this.createMenuItem({
      key: 'resources-menu-item-1',
      primaryText: 'FAQ',
      linkTo: helpDeskLink,
      onClickTab: true,
      onClickTerm: 'Menu: Resources > FAQ',
    }),
    this.createMenuItem({
      key: 'resources-menu-item-2',
      primaryText: 'Support',
      linkTo: supportLink,
      onClickTab: true,
      onClickTerm: 'Menu: Resources > Support',
    }),
    this.createMenuItem({
      key: 'resources-menu-item-3',
      primaryText: 'Developer Center',
      linkTo: 'http://developer.flightstats.com/?utm_source=flightstats&utm_medium=ResourcesMenuLink&utm_campaign=DeveloperCenter',
      onClickTerm: 'Menu: Resources > Developer Center',
    }),
    this.createMenuItem({
      key: 'resources-menu-item-4',
      primaryText: 'Careers',
      linkTo: 'https://www.flightstats.com/company/corporate/careers/',
      onClickTerm: 'Menu: Resources > Careers',
    }),
    this.createMenuItem({
      key: 'resources-menu-item-5',
      primaryText: 'Contact',
      linkTo: 'https://www.flightstats.com/company/contact/',
      onClickTerm: 'Menu: Resources > Contact',
    }),
    this.createMenuItem({
      key: 'resources-menu-item-6',
      primaryText: 'On-Time Performance Awards',
      linkTo: 'https://www.flightstats.com/company/media/on-time-performance-awards/',
      onClickTerm: 'Menu: Resources > On-Time Performance Awards',
    }),
  ];

  statsMenuItems = () => [
    this.createMenuItem({
      key: 'stats-menu-item-1',
      primaryText: 'Airline On-time Performance Reports',
      linkTo: '/monthly-performance-reports/airlines',
      // leftIcon: AirlineOTPIcon,
      onClickTerm: 'Menu: Stats > Airline OTP',
    }),
    this.createMenuItem({
      key: 'stats-menu-item-2',
      primaryText: 'Airport On-time Performance Reports',
      linkTo: '/monthly-performance-reports/airports',
      // leftIcon: AirportOTPIcon,
      onClickTerm: 'Menu: Stats > Airport OTP',
    }),
    this.createMenuItem({
      key: 'stats-menu-item-3',
      primaryText: 'Global Cancellations and Delays',
      linkTo: '/global-cancellations-and-delays',
      // leftIcon: GlobalCancelDelaysIcon,
      onClickTerm: 'Menu: Stats > Global Cancellations Delays',
    }),
  ];

  companyMenuItems = () => [
    this.createMenuItem({
      key: 'company-menu-item-1',
      primaryText: 'About Us',
      linkTo: 'https://www.flightstats.com/company/corporate/about-us/',
      onClickTerm: 'Menu: Company > About Us',
    }),
    this.createMenuItem({
      key: 'company-menu-item-2',
      primaryText: 'Products',
      linkTo: 'https://www.flightstats.com/company/products/',
      onClickTerm: 'Menu: Company > Products',
    }),
    this.createMenuItem({
      key: 'company-menu-item-3',
      primaryText: 'Markets',
      linkTo: 'https://www.flightstats.com/company/markets/',
      onClickTerm: 'Menu: Company > Markets',
    }),
    this.createMenuItem({
      key: 'company-menu-item-4',
      primaryText: 'Data',
      linkTo: 'https://www.flightstats.com/company/corporate/data/',
      onClickTerm: 'Menu: Company > Data',
    }),
    this.createMenuItem({
      key: 'company-menu-item-5',
      primaryText: 'Platform',
      linkTo: 'https://www.flightstats.com/company/corporate/platform/',
      onClickTerm: 'Menu: Company > Platform',
    }),
    this.createMenuItem({
      key: 'company-menu-item-6',
      primaryText: 'Customers',
      linkTo: 'https://www.flightstats.com/company/corporate/customers/',
      onClickTerm: 'Menu: Company > Customers',
    }),
    this.createMenuItem({
      key: 'company-menu-item-7',
      primaryText: 'Partners',
      linkTo: 'https://www.flightstats.com/company/corporate/partners/',
      onClickTerm: 'Menu: Company > Partners',
    }),
  ];

  myFlightStatsMenuItems = () => [
    this.createMenuItem({
      key: 'my-flightstats-menu-item-1',
      primaryText: 'My Alerts',
      linkTo: '/flight-alerts/home',
      // leftIcon: this.context.images.menuIcons.flightAlerts,
      showLock: !this.subscriptionActive(),
      onClickTerm: 'Menu: My FlightStats > My Alerts',
    }),
    this.createMenuItem({
      key: 'my-flightstats-menu-item-2',
      primaryText: 'My Account',
      linkTo: '/my-account/profile',
      // leftIcon: SettingsIcon,
      onClickTerm: 'Menu: My FlightStats > My Account',
    }),
  ];

  accountMenuItems = () => {
    if (this.props.user) {
      return [
        this.createMenuItem({
          key: 'account-menu-item-1',
          primaryText: 'Logout',
          linkTo: '/account/login',
          onClickTerm: 'Logout',
          // leftIcon: LogoutIcon,
          onClick: ((e) => {
            e.preventDefault();
            this.onNavItemSelected();
            this.logout();
          }),
        }),
        this.createMenuItem({
          key: 'account-menu-item-2',
          primaryText: 'My Account',
          linkTo: '/my-account/profile',
          // leftIcon: SettingsIcon,
          onClickTerm: 'MyAccount',
        }),
        this.createMenuItem({
          key: 'account-menu-item-3',
          primaryText: 'My Alerts',
          linkTo: '/flight-alerts/home',
          // leftIcon: this.context.images.menuIcons.flightAlerts,
          showLock: !this.subscriptionActive(),
          onClickTerm: 'Search',
        }),
        <MenuItem
          key='account-menu-item-4'
          className='menu-item'
          style={{ backgroundColor: 'transparent' }}
          innerDivStyle={{
            color: '#FFFFFF',
            backgroundColor: '#81A2CA',
            margin: '19px',
            borderRadius: '3px',
            paddingLeft: '63px',
            paddingRight: '0',
            fontSize: '20px',
          }}
        >
          {this.bigBlueAccountButton()}
        </MenuItem>,
      ];
    }

    return [
      this.createMenuItem({
        key: 'account-menu-item-1',
        primaryText: 'Login',
        linkTo: '/account/login',
        // leftIcon: LoginIcon,
        onClickTerm: 'Login',
      }),
      this.createMenuItem({
        key: 'account-menu-item-2',
        primaryText: 'Create Account',
        linkTo: '/register/plan',
        // leftIcon: CreateAccountIcon,
        onClickTerm: 'SignUp',
      }),
    ];
  }

  socialOnClick = (e, social) => {
    this.context.reportSendInteraction(social);
    openTab(social.socialTarget, e);
  }

  mediaIcon = (icon, link, socialNetwork, action) => {
    const social = {
      hitType: 'social',
      socialNetwork,
      socialAction: action || 'follow',
      socialTarget: link,
    };

    return (
      <Link to={link} onClick={e => this.socialOnClick(e, social)}>
        <Icon src={icon} />
      </Link>
    );
  };

  followIcons = isMobile => (
    <div className={`${isMobile ? 'social-follow-container-mobile' : 'social-follow-container'}`}>
      Follow us on
      <div className='icons-container'>
        {this.mediaIcon(facebookIcon, 'https://www.facebook.com/pages/FlightStats/6305094086', 'Facebook', 'like')}
        {this.mediaIcon(twitterIcon, 'https://twitter.com/flightstats', 'Twitter')}
        {this.mediaIcon(linkedinIcon, 'https://www.linkedin.com/company/flightstats', 'LinkedIn')}
        {this.mediaIcon(youtubeIcon, 'https://www.youtube.com/channel/UC0lOB-YgtxGYiBFIo9f3hww', 'YouTube', 'subscribe')}
      </div>
    </div>
  );

  render() {
    // isMobile handles high density larger screen phones
    /*
      const mobile = this.context.mediaBreakpoint.isMobile;
      // || (this.context.mediaBreakpoint.value <= breakpoints.tablet);
    */
    const { mobile } = this.state;
    const bigBlueAccountButton = this.bigBlueAccountButton();
    let topRightAdditionalSpace = null;

    let headerNavItems = null;
    let appBarChildren = null;
    let leftNav = null;

    const headerNavArray = [
      <li
        key='header-nav-1'
        className='header-logo'
        style={{
          height: '84px', // corresponds to the size of the FS part of FG... logo
        }}
      >
        {
          <LogoLink
            anchorClass={logoLinkAnchorClass}
            imgClass={logoLinkImgClass}
            linkTo='/'
            logo={FSFGLogo}
            mobileClass={this.getLogoLinkMobileClass(mobile)}
            reportButtonPress={this.context.reportButtonPress}
          />
        }
      </li>,
    ];

    let topRightButtons = null;

    if (mobile) {
      leftNav = (
        <Drawer
          width={260}
          className='fs-header-left-nav'
          docked
          open={this.state.menuOpen}
          onRequestChange={menuOpen => this.setState({ menuOpen })}
        >
          {this.followIcons(mobile)}
          {this.createDrawerSection('Flights', this.flightsMenuItems())}
          {this.createDrawerSection('Airports', this.airportsMenuItems())}
          {this.createDrawerSection('Company', this.companyMenuItems())}
          {this.createDrawerSection('Resources', this.resourcesMenuItems())}
          {this.createDrawerSection('Account', this.accountMenuItems())}
        </Drawer>
      );
    } else {
      let flightsMenu = null;
      let airportsMenu = null;
      let resourcesMenu = null;
      let statsMenu = null;
      let companyMenu = null;
      let myFlightStatsMenu = null;

      const menuStyle = {
        position: 'absolute',
        top: '39px',
        right: null,
        backgroundColor: '#FFF',
        zIndex: 999,
        width: '224px',
        lineHeight: '9px',
        padding: '18px 0',
        boxShadow: 'rgba(0,0,0, .118) 0px 3px 3px',
      };

      const listStyle = {
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: 'transparent',
      };

      if (this.state.visibleMenu === 'flights-nav') {
        flightsMenu = (
          <Menu
            key='main-header-menu-1'
            className='main-header-menu'
            style={menuStyle}
            listStyle={listStyle}
          >
            {this.flightsMenuItems()}
          </Menu>
        );
      } else if (this.state.visibleMenu === 'airports-nav') {
        airportsMenu = (
          <Menu
            key='main-header-menu-2'
            className='main-header-menu'
            style={menuStyle}
            listStyle={listStyle}
          >
            {this.airportsMenuItems()}
          </Menu>
        );
      } else if (this.state.visibleMenu === 'resources-nav') {
        const resourcesMenuStyle = {
          ...menuStyle,
          width: '240px',
        };
        resourcesMenu = (
          <Menu
            key='main-header-menu-3'
            className='main-header-menu'
            style={resourcesMenuStyle}
            listStyle={listStyle}
          >
            {this.resourcesMenuItems()}
          </Menu>
        );
      } else if (this.state.visibleMenu === 'stats-nav') {
        statsMenu = (
          <Menu
            key='main-header-menu-5'
            className='main-header-menu'
            style={{
              ...menuStyle,
              width: '281px',
            }}
            listStyle={listStyle}
          >
            {this.statsMenuItems()}
          </Menu>
        );
      } else if (this.state.visibleMenu === 'company-nav') {
        companyMenu = (
          <Menu
            key='main-header-menu-6'
            className='main-header-menu'
            style={{
              ...menuStyle,
              width: '150px',
            }}
            listStyle={listStyle}
          >
            {this.companyMenuItems()}
          </Menu>
        );
      } else if (this.state.visibleMenu === 'my-flightstats-nav') {
        myFlightStatsMenu = (
          <Menu
            key='main-header-menu-4'
            className='main-header-menu'
            style={menuStyle}
            listStyle={listStyle}
          >
            {this.myFlightStatsMenuItems()}
          </Menu>
        );
      }

      headerNavItems = (
        <li key='header-nav-2' className='fs-header-nav'>
          {this.createHeaderNavItem('flights-nav', 'Flights', flightsMenu)}
          {this.createHeaderNavItem('airports-nav', 'Airports', airportsMenu)}
          {this.createHeaderNavItem('stats-nav', 'Stats', statsMenu)}
          {this.createHeaderNavItem('company-nav', 'Company', companyMenu)}
          {this.createHeaderNavItem('resources-nav', 'Resources', resourcesMenu)}
          {this.createHeaderNavItem('my-flightstats-nav', 'My FlightStats', myFlightStatsMenu, 'right-nav')}
        </li>
      );

      headerNavArray.push(headerNavItems);
    }

    if (!mobile) {
      let iconElementRight = null;

      const flatButtonStyle = FSFlatButton.style({
        textTransform: 'none',
        minWidth: 0,
      });
      const labelStyle = {
        color: Colors.orange1,
        paddingLeft: 5,
        paddingRight: 3,
        letterSpacing: 2,
        fontWeight: 600,
        textTransform: 'none',
      };

      if (this.props.user) {
        iconElementRight = (
          <FlatButton
            className='logout-button'
            style={flatButtonStyle}
            labelStyle={labelStyle}
            label='Logout'
            onClick={this.logout}
          />
        );
      } else {
        iconElementRight = (
          <FlatButton
            className='login-button'
            labelStyle={labelStyle}
            label='Login'
            onClick={this.context.gotoHandler('/account/login', 'Login')}
            style={flatButtonStyle}
          />
        );
      }

      if (bigBlueAccountButton && iconElementRight) {
        topRightAdditionalSpace = true;
      }

      topRightButtons = (
        <div
          className={`top-right-btns ${topRightAdditionalSpace ? ' blue-btn' : ''}`}
          style={{ float: 'right', marginRight: '22px' }}
        >
          {this.followIcons()}
          <div style={{ float: 'right' }}>
            {bigBlueAccountButton}
            {iconElementRight}
          </div>
        </div>
      );
    }

    const pathName = this.props.location && this.props.location.pathname;

    appBarChildren = (
      <AppBarChildren
        headerNavArray={headerNavArray}
        hideHeader={this.hideHeader}
        logoLinkAnchorClass={logoLinkAnchorClass}
        imgClass={logoLinkImgClass}
        logo={FSFGLogo}
        mobileClass={this.getLogoLinkMobileClass(mobile)}
        pathName={pathName}
        reportButtonPress={this.context.reportButtonPress}
        topRightButtons={topRightButtons}
      />
    );

    return (
      <div
        className={(mobile ? 'mobile' : null)}
      >
        {/* display is overwritten in CSS.
          * This prevents mismatch between server and client render -@ma
        */}
        <AppBar
          style={{ display: 'none' }}
          className='fs-header'
          showMenuIconButton={mobile && !this.hideHeader(pathName)}
          onLeftIconButtonTouchTap={this.onHamburgerTap}
        >
          {appBarChildren}
        </AppBar>
        {leftNav}
        {this.props.isLoading ? <LinearProgress mode='indeterminate' color='#FAA718' style={{ backgroundColor: 'rgba(97, 78, 45, 1.0)' }} /> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/App/components/children/Header/HeaderComponent.js